import React from 'react';
import ReactDOM from 'react-dom';
import { View, StyleSheet, TouchableOpacity, Text } from 'react-native';
import { FaTimes } from 'react-icons/fa';
import { useTheme } from '../theme/ThemeContext';

let THEME = {};
const getStyles = () => StyleSheet.create({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
    },
    backdrop: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: THEME.overlay,
        zIndex: -1,
    },
    modalContainer: {
        width: '90%',
        maxWidth: 700,
        maxHeight: '90vh',
        backgroundColor: THEME.modalBg,
        borderRadius: 20,
        borderWidth: 1,
        borderColor: THEME.border,
        overflow: 'hidden',
        boxShadow: '0 10px 20px rgba(0,0,0,0.5)',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 16,
        borderBottomWidth: 1,
        borderBottomColor: THEME.border,
        backgroundColor: THEME.bgCard,
    },
    title: {
        color: THEME.textPrimary,
        fontSize: 18,
        fontWeight: 'bold',
    },
    closeButton: {
        padding: 8,
        borderRadius: 8,
        backgroundColor: THEME.bgSurface,
    },
    closeIcon: {
        color: THEME.textSecondary,
        fontSize: 16,
    },
    content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
});
let styles = getStyles();

const Modal = ({ isVisible, onClose, title, children, width, maxWidth, headerRight }) => {
    const { theme } = useTheme();
    Object.assign(THEME, theme);
    styles = getStyles();

    if (!isVisible) return null;

    return ReactDOM.createPortal(
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            zIndex: 99999,
            paddingTop: 60,
        }}>
            {/* Backdrop */}
            <div
                style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: THEME.overlay, backdropFilter: 'blur(6px)' }}
                onClick={onClose}
            />
            {/* Modal card */}
            <View style={[
                styles.modalContainer,
                width && { width },
                maxWidth && { maxWidth },
                { zIndex: 1 },
            ]}>
                {/* Header */}
                <View style={styles.header}>
                    <Text style={styles.title}>{title}</Text>
                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12 }}>
                        {headerRight}
                        <TouchableOpacity onPress={onClose} style={styles.closeButton}>
                            <FaTimes style={styles.closeIcon} />
                        </TouchableOpacity>
                    </View>
                </View>

                {/* Content */}
                <View style={styles.content}>
                    {children}
                </View>
            </View>
        </div>,
        document.body
    );
};


export default Modal;
